import moment from "moment";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Loading from "./loading";
import { formatDOB } from "../consts/dateMask";
import { setFcwdOnly } from "../../utils/data";
import { countryOptions } from "../../utils/countryOptions";

function Withdrawals() {
    const {source, userState, email, token} = useAuth();
    const [tableData, setTableData] = useState([]);
    const [validated, setValidated] = useState(false);
    const [errorMessages, setErrorMessages] = useState(['', '']);
    const [formData, setFormData] = useState({
        Header: {
            Metadata: {
                UserID: email //to be replaced with db email
            }
        },
        Body: {
            Source:{
                DataSource: source
            },
            JurisdictionCodeConvicting: userState,
            StartDate: "",
            EndDate: ""
        }
    });
    const [loading, setLoading] = useState(false);
    const [requestSent, setRequestSent] = useState(false);
    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target;
        setErrorMessages(['', '']);

        if (form.checkValidity() === false) {
            if(!formData.Body.StartDate){
                setErrorMessages(prev => [prev[0], 'Please enter a Start Date.']);
            }
            if(!formData.Body.EndDate){
                setErrorMessages(prev => [prev[1], 'Please enter an End Date.']);
            }
            if(formData.Body.StartDate && formData.Body.EndDate && moment(formData.Body.EndDate).isBefore(moment(formData.Body.StartDate))){
                setErrorMessages(prev => [prev[1], 'End Date must be equal to or greater than State Date.']);
            }
            e.stopPropagation(); // prevent submit if invalid
        } else {
            console.log(formData);
            setLoading(true);
            try {
                fetch(`/api/withdrawals`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(formData),
                })
                .then(response => response.json())
                .then(data => {
                    console.log('API Response:', data);
                    setTableData(data?.Withdrawals || []);
                    setLoading(false);
                    setRequestSent(true);
                })
                .catch((error) => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        }
        setValidated(true);
    }
    const handleDataChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            Body: {...formData.Body, [name]: value}
        });
    }
    const viewDriver = (driverState, driverLicense) => {
        const isFCWD = countryOptions["US"].some(c => c.code === driverState) || countryOptions["OTH"].some(c => c.code === driverState);
        setFcwdOnly(isFCWD);
        navigate(`/driverdetails/${driverState}/${encodeURIComponent(driverLicense)}`);
    }

    const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
            return;
        }
        setFormData((formData) => ({ ...formData, [name]: 0 }));
  }

  return (
    <><div className="App">
          <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" noValidate onSubmit={handleSubmit}>
              <div className="row">
                  <div className="col-md-3">
                      <label for="inputStart" className="form-label"><b><span className="text-danger">*</span> Start Date</b></label>
                      <input type="date" className="form-control is-invalid" 
                          placeholder="MM/DD/YYYY" name='StartDate' onChange={handleDataChange} max={moment().format("YYYY-MM-DD")}
                          onKeyDown={(e) => disableKey(e)}
                          pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' required />
                          <div className="invalid-feedback">{errorMessages[0]}</div>
                  </div>
                  <div className="col-md-3">
                      <label for="inputEnd" className="form-label"><b><span className="text-danger">*</span> End Date</b></label>
                      <input type="date" className="form-control is-invalid"
                          placeholder="MM/DD/YYYY" name='EndDate' onChange={handleDataChange} min={formData.Body.StartDate} max={moment().format("YYYY-MM-DD")}
                          onKeyDown={(e) => disableKey(e)}
                          pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' required />
                          <div className="invalid-feedback">{errorMessages[1]}</div>
                  </div>
                  <div className="col-md-5">
                        <button type="submit" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}}>Get Withdrawals</button>

                    </div>
              </div>
          </form>
      </div>
      {loading &&
            <Loading />}
      {requestSent && tableData.length > 0 ? (
      <div className=" App table-scroll-container" id="table">
        <table class="table table-striped table-bordered">
        <thead class="table-header sticky-header">
            <tr>
            <th scope="col">Actions</th>
            <th scope="col">Driver State</th>
            <th scope="col">Driver License</th>
            <th scope="col">Effective Date</th>
            <th scope="col">Eligibility Date</th>
            <th scope="col">Reinstatement Date</th>
            <th scope="col">SOW</th>
            <th scope="col">Withdrawal ID</th>
            <th scope="col">Link</th>
            <th scope="col">ACD Code</th>
            <th scope="col">Action</th>
            <th scope="col">Basis</th>
            <th scope="col">Extent</th>
            <th scope="col">Due Process Status</th>
            <th scope="col">WD Locator Number</th>
            <th scope="col">State Native Code</th>
            <th scope="col">User ID</th>
            <th scope="col">Date Posted</th>
            {/* <th scope="col">Conviction Withdrawal Code</th>
            <th scope="col">Conviction Review Reason</th>
            <th scope="col">Jurisdiction Data</th>
            <th scope="col">Foreign Data</th>
            <th scope="col">Review Received Date</th> */}
            </tr>
        </thead>
        <tbody>
            {tableData.map((row, index) => (
                
            <tr>
            <td>
                <button className="btn btn-link" onClick={() => viewDriver(row.driver_state, row.driver_license_number)} 
                style={{ padding: 0, border: "none", background: "none" }}
                >View</button>
            </td>
            
            <td>{row.driver_state}</td>
            <td>{row.driver_license_number}</td>
            <td>{row.withdrawal_effective_date}</td>
            <td>{row.withdrawal_eligibility_date}</td>
            <td>{row.withdrawal_reinstate_date}</td>
            <td>{row.withdrawal_jurisdiction_code}</td>
            <td>{row.withdrawal_id}</td>
            <td>{row.DLWithdrawalIdConvictionLinksGroup}</td>
            <td>{row.withdrawal_acd_code}</td>
            <td>{row.withdrawal_action_type_code}</td>
            <td>{row.withdrawal_basis_code}</td>
            <td>{row.withdrawal_extent_code}</td>
            <td>{row.withdrawal_due_process_status_code}</td>
            <td>{row.withdrawal_jurisdiction_locator}</td>
            <td>{row.withdrawal_reason_reference}</td>
            <td>{row.withdrawal_userid}</td>
            <td>{moment(row.withdrawal_date_posted).format("MM/DD/YYYY h:mm:ss A")}</td>
            {/* <td>Conviction Withdrawal Code</td>
            <td>Conviction Review Reason</td>
            <td>Jurisdiction Data</td>
            <td>Foreign Data</td>
            <td>Review Received Date</td> */}
            </tr>
            ))}

        </tbody>
        </table> 
      </div>) : (requestSent &&
            <div class="alert alert-danger" role="alert" style={{"width":"100%", "margin":"auto", "textAlign":"center"}}>
                No Records to show.
            </div> 
            )
        }
    </>
  );
}
export default Withdrawals;